var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Cards',{staticClass:"cards--grid-nav",attrs:{"per-row":"4","md-per-row":"4","sm-per-row":"2","xs-per-row":"1"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }